import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'

const initialState: InitialState = {
  page: null,
  isFetching: false,
  themes: [],
  courseStatistic: null,
  isFetchingThemes: false,
  isProcessCreateTheme: false,
  isProcessEditTheme: false,
  isProcessRemoveTheme: false,
  isProcessSave: false,
  isProcessRemove: false,
  isProcessStatistic: false,
  isProcessCreateMap: false,
  isProcessRemoveMap: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchCourse]: state => {
      return {
        ...state,
        isFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchCourseSuccess]: (state, action) => {
      return {
        ...state,
        page: action.result,
        isFetching: false,
      }
    },
    [actions.fetchCourseFailure]: (state, action) => {
      return {
        ...state,
        isFetching: false,
        error: action.error,
      }
    },
    [actions.fetchThemes]: state => {
      return {
        ...state,
        isFetchingThemes: true,
      }
    },
    [actions.fetchThemesSuccess]: (state, action) => {
      return {
        ...state,
        themes: action.result,
        isFetchingThemes: false,
      }
    },
    [actions.fetchThemesFailure]: (state, action) => {
      return {
        ...state,
        isFetchingThemes: false,
        error: action.error,
      }
    },
    [actions.editCourse]: state => {
      return {
        ...state,
        isProcessSave: true,
      }
    },
    [actions.editCourseSuccess]: state => {
      return {
        ...state,
        isProcessSave: false,
      }
    },
    [actions.editCourseFailure]: (state, action) => {
      return {
        ...state,
        isProcessSave: false,
        error: action.error,
      }
    },
    [actions.removeCourse]: state => {
      return {
        ...state,
        isProcessRemove: true,
      }
    },
    [actions.removeCourseSuccess]: state => {
      return {
        ...state,
        isProcessRemove: false,
      }
    },
    [actions.removeCourseFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemove: false,
        error: action.error,
      }
    },
    [actions.fetchCourseStatistic]: state => {
      return {
        ...state,
        isProcessStatistic: true,
      }
    },
    [actions.fetchCourseStatisticSuccess]: (state, action) => {
      return {
        ...state,
        courseStatistic: action.result,
        isProcessStatistic: false,
      }
    },
    [actions.fetchCourseStatisticFailure]: (state, action) => {
      return {
        ...state,
        isProcessStatistic: false,
        error: action.error,
      }
    },
    [actions.createTheme]: state => {
      return {
        ...state,
        isProcessCreateTheme: true,
      }
    },
    [actions.createThemeSuccess]: state => {
      return {
        ...state,
        isProcessCreateTheme: false,
      }
    },
    [actions.createThemeFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreateTheme: false,
        error: action.error,
      }
    },
    [actions.editTheme]: state => {
      return {
        ...state,
        isProcessEditTheme: true,
      }
    },
    [actions.editThemeSuccess]: state => {
      return {
        ...state,
        isProcessEditTheme: false,
      }
    },
    [actions.editThemeFailure]: (state, action) => {
      return {
        ...state,
        isProcessEditTheme: false,
        error: action.error,
      }
    },
    [actions.removeTheme]: state => {
      return {
        ...state,
        isProcessRemoveTheme: true,
      }
    },
    [actions.removeThemeSuccess]: state => {
      return {
        ...state,
        isProcessRemoveTheme: false,
      }
    },
    [actions.removeThemeFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveTheme: false,
        error: action.error,
      }
    },
    [actions.createMap]: state => {
      return {
        ...state,
        isProcessCreateMap: true,
      }
    },
    [actions.createMapSuccess]: state => {
      return {
        ...state,
        isProcessCreateMap: false,
      }
    },
    [actions.createMapFailure]: (state, action) => {
      return {
        ...state,
        isProcessCreateMap: false,
        error: action.error,
      }
    },
    [actions.removeMap]: state => {
      return {
        ...state,
        isProcessRemoveMap: true,
      }
    },
    [actions.removeMapSuccess]: state => {
      return {
        ...state,
        isProcessRemoveMap: false,
      }
    },
    [actions.removeMapFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveMap: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
